import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HttpUtils } from '../../../../../common/http/http-utils';

@Injectable()
export class Service {
  value = '';

  constructor(public http: HttpClient) {
  }

  getDeletedVappsForVDC(vdcId) {
    return this.http
      .get(HttpUtils.getBaseUrl() + '/hybridity/api/dps/vdc/' + vdcId + '/deletedVApps')
      .map(
        (res: any) => this.value = res
      );
  }
  getAllDeletedVapps() {
    return this.http
      .get(HttpUtils.getBaseUrl() + '/hybridity/api/dps/deletedVApps')
      .map(
        (res: any) => this.value = res
      );
  }
}



// WEBPACK FOOTER //
// ./src/app/components/dataprotection/dataprotection-vcd/deleted-vapps/deleted-vapps.service.ts